export const DATE_FORMAT = "EEEE, MMMM do yyyy"
export const SHORT_DATE_FORMAT_HEBREW = "d בMMMM"
export const SHORT_DATE_FORMAT_ENGLISH = "MMMM d"
